import type { ReactNode } from "react";
import styles from "./TemplateAuthentication.module.css";
// @ts-expect-error pure js
import { classnames } from "../../utils";
// @ts-expect-error pure js
import { Qalimo } from "./Icons.jsx";
import Text from "./Text.tsx";
import Title from "./Title.tsx";

interface TemplateAuthenticationProps {
  children: ReactNode;
  sidePanel?: ReactNode;
  wide?: boolean;
}

export default function TemplateAuthentication({
  children,
  sidePanel,
  wide,
}: TemplateAuthenticationProps) {
  return (
    <div className={styles.page}>
      <div className={classnames(styles.side, styles.left)}>
        {sidePanel ?? (
          <div className={classnames(styles.welcome)}>
            <div className={styles.logo}>
              <Qalimo size={48} fill="#EFF4FF" />
              <Text as="span" color="white" variant="tera">
                alimo
              </Text>
            </div>
            <Title variant="mega" color="white">
              Bienvenue chez Qalimo !
            </Title>
            <Text color="white">Simplifier votre gestion locative.</Text>
          </div>
        )}
      </div>
      <div className={classnames(styles.side, styles.right)}>
        <div className={classnames(styles.form, wide && styles.wide)}>
          {children}
        </div>
      </div>
    </div>
  );
}
